import { ShieldCrownOutlineIcon } from './ShieldCrownOutlineIcon';

/**
 * author: Michael Miday
 * id 97DA53AC-FC83-467F-A814-752C981BFEDE
 * name shield-crown-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-crown-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const AdministratorOutlineIcon = ShieldCrownOutlineIcon;
export default AdministratorOutlineIcon